/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, ref } from "vue";

export default (func: (...args: any[]) => any, time = 1000) => {
  const debounceToken = ref<NodeJS.Timeout | null>(null);
  const waiting = computed(() => debounceToken.value !== null);
  const clear = () => {
    debounceToken.value && clearTimeout(debounceToken.value);
    debounceToken.value = null;
  };
  const call = (...args: any[]) => {
    if (debounceToken.value) clear();
    debounceToken.value = setTimeout(() => func(...args), time);
  };
  const force = (...args: any[]) => {
    clear();
    func(args);
  };
  return {
    call,
    clear,
    force,
    waiting,
  };
};
